import React from "react";

const LABELS = {
  computational_check: { text: "Computational Check", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  expert_review: { text: "Expert Review", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  formally_checked_proof: { text: "Formally Checked Proof", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

const STATUS = {
  draft: { text: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  open: { text: "Open for Submissions", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  in_review: { text: "In Review", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  under_review: { text: "Under Review", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  submitted: { text: "Submitted", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  awarded: { text: "Awarded", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  accepted: { text: "Accepted", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { text: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  disputed: { text: "In Tribunal", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  refunded: { text: "Refunded", cls: "bg-slate-100 text-slate-600 border-slate-300" },
};

export const VerdictLabel = ({ label }) => {
  const l = LABELS[label] || { text: label, cls: "bg-slate-100 text-slate-600 border-slate-300" };
  return (
    <span data-testid={`verdict-label-${label}`} className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${l.cls}`}>
      {l.text}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || { text: status, cls: "bg-slate-100 text-slate-600 border-slate-300" };
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${s.cls}`}>
      {s.text}
    </span>
  );
};
